/**
 * O que faz: Exibe resumo clicavel de um conteudo publico com metadados essenciais.
 * Onde usa: Listagens de BlogIndexPage e BlogCategoryPage.
 * Conexoes: Recebe PublicContentItem gerado e encaminha para rota publica correspondente.
 * Tabelas: Nao interage com Supabase; representa apenas dados estaticos aprovados.
 * Data: 09/05/2026
 */

import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import type { PublicContentItem } from "@/content/types";

type ContentCardProps = {
  item: PublicContentItem;
  variant?: "default" | "featured" | "compact";
};

const ContentCard = ({ item, variant = "default" }: ContentCardProps) => {
  return (
    <article className={`public-card public-card-${variant}`}>
      <p className="public-card-meta">
        <span>{item.category}</span>
        <span>
          <CalendarDays size={14} />
          Atualizado em {item.updatedAt}
        </span>
      </p>
      <h2>
        <Link to={item.url}>{item.title}</Link>
      </h2>
      <p>{item.description}</p>
      <p className="public-card-audience">Público: {item.audience}</p>
      <Link to={item.url} className="public-card-link">
        Ler conteúdo
        <ArrowRight size={15} />
      </Link>
    </article>
  );
};

export default ContentCard;
